<template>
  <div class="testInfo">
    <div class="form">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="170px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="账号">
              <span style="padding-left: 15px">{{ userInfo.mobile }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item
              label="机构名称"
              prop="mechanism_fullName"
              :error="error2"
            >
              <el-input
                v-model="ruleForm.mechanism_fullName"
                placeholder="请输入机构名称"
                @blur="checkNickName(2)"
                style="width: 100%"
                v-if="!isdisabled"
              ></el-input>
              <span v-else style="padding-left: 15px">{{
                ruleForm.mechanism_fullName
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <!-- :error="error1" -->
            <el-form-item label="简称" :error="error1" prop="nickname">
              <el-input
                v-model="ruleForm.nickname"
                @blur="checkNickName(1)"
                maxlength="8"
                placeholder="请输入简称"
                style="width: 100%"
                v-if="!isdisabled"
              ></el-input>
              <span v-else style="padding-left: 15px">{{
                ruleForm.nickname
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="机构实景">
              <el-upload
                action="#"
                accept=".png, .jpeg, .jpg"
                list-type="picture-card"
                :auto-upload="false"
                :multiple="true"
                :on-change="handlePictureCard"
                :limit="3"
                :on-exceed="onExceed"
                :file-list="fileList"
                ref="upLoad"
              >
                <i slot="default" class="el-icon-plus"></i>
                <!--<i slot="default" class="el-icon-delete" v-if="!disabled" @click.stop="handleRemove()"></i>-->
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handleViewImg(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      class="el-upload-list__item-delete"
                      v-if="!disabled"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <p v-if="!personalInfo && disabled">
                <img
                  src="/image/personal/default_ava.jpg"
                  alt
                  style="width: 200px; height: 200px"
                />
              </p>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
              <span v-if="!disabled" style="color: #e6a23c"
                >首张照片将作为测试机构展示、等级测试班级展示时的机构头像（最多可上传三张实景图）</span
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="营业执照编号" prop="business_license">
              <el-input
                v-model="ruleForm.business_license"
                placeholder="请输入营业执照编号"
                style="width: 100%"
                :class="isdisabled ? 'border' : ''"
                :readOnly="isdisabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="机构注册地址" required>
              <el-row
                :gutter="10"
                style="width: 100%; margin-left: 0px"
                v-if="!isdisabled"
              >
                <el-col :xs="8" :sm="8" :md="8" style="padding-left: 0px">
                  <el-form-item prop="province" class="content">
                    <el-select
                      v-model="ruleForm.province"
                      placeholder="请选择省"
                      style="width: 100%"
                      :isdisabled="isdisabled"
                      @change="chooseProvince($event)"
                    >
                      <el-option
                        v-for="item in province"
                        :key="item.id"
                        :label="item.area_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8">
                  <el-form-item prop="city" class="content">
                    <el-select
                      v-model="ruleForm.city"
                      placeholder="请选择市"
                      style="width: 100%"
                      :isdisabled="isdisabled"
                      @change="chooseCity($event)"
                    >
                      <el-option
                        v-for="item in city"
                        :key="item.id"
                        :label="item.area_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" style="padding-right: 0px">
                  <el-form-item prop="district" class="content">
                    <el-select
                      v-model="ruleForm.district"
                      placeholder="请选择地区"
                      style="width: 100%"
                      :isdisabled="isdisabled"
                      @change="chooseDistrict($event)"
                    >
                      <el-option
                        v-for="item in district"
                        :key="item.id"
                        :label="item.area_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <span
         v-else
         style="padding: 0 15px;"
              >{{ruleForm.province|pro}} {{ruleForm.city|cit}} {{ruleForm.district|dis}} {{ruleForm.detailed_address}}</span>-->
              <span v-else style="padding: 0 15px"
                >{{
                  ruleForm.provinceName == ruleForm.cityName
                    ? ruleForm.provinceName
                    : ruleForm.provinceName + ruleForm.cityName
                }}{{ ruleForm.districtName
                }}{{ ruleForm.detailed_address }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="!isdisabled">
            <el-form-item label prop="detailed_address">
              <el-input
                v-model="ruleForm.detailed_address"
                placeholder="请输入机构注册详细地址"
                style="width: 100%"
                :class="isdisabled ? 'border' : ''"
                :readOnly="isdisabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="办公地址" prop="office_address">
              <el-input
                v-model="ruleForm.office_address"
                placeholder="请输入办公地址"
                style="width: 100%"
                :class="disabled ? 'border' : ''"
                :readOnly="disabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="负责人姓名" prop="principal">
              <el-input
                v-model="ruleForm.principal"
                placeholder="请输入负责人姓名"
                style="width: 100%"
                :class="disabled ? 'border' : ''"
                :readOnly="disabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="负责人联系电话" prop="principal_tel">
              <el-input
                v-model="ruleForm.principal_tel"
                placeholder="请输入负责人联系电话"
                style="width: 100%"
                :class="disabled ? 'border' : ''"
                :readOnly="disabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="法人姓名" prop="legal_person">
              <el-input
                v-model="ruleForm.legal_person"
                placeholder="请输入法人姓名"
                style="width: 100%"
                :class="isdisabled ? 'border' : ''"
                :readOnly="isdisabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="法人证件类型" prop="certificates_type">
              <el-select
                v-model="ruleForm.certificates_type"
                placeholder="请选择法人证件类型"
                :disabled="disabled"
                style="width: 100%"
                v-if="!isdisabled"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in certificatesList"
                  :key="index"
                ></el-option>
              </el-select>
              <span v-else style="padding: 0 15px">{{
                ruleForm.certificates_type | type
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="法人证件号码" prop="legal_person_idNumber">
              <el-input
                v-model="ruleForm.legal_person_idNumber"
                placeholder="请输入法人证件号码"
                style="width: 100%"
                :class="isdisabled ? 'border' : ''"
                :readOnly="isdisabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="法人联系电话" prop="management_tel">
              <el-input
                v-model="ruleForm.management_tel"
                placeholder="法人联系电话"
                style="width: 100%"
                :class="disabled ? 'border' : ''"
                :readOnly="disabled ? true : false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item class="submit">
              <el-button
                type="danger"
                @click="edit()"
                style="width: 100px; height: 40px"
                v-if="disabled"
                >编 辑
              </el-button>
              <el-button
                type="danger"
                @click="edit1()"
                style="width: 100px; height: 40px"
                v-if="!disabled && personalInfo"
                >取消编辑
              </el-button>
              <el-button
                type="danger"
                @click="submit('ruleForm')"
                style="width: 100px; height: 40px"
                :loading="loading"
                v-if="!disabled"
                >提 交
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { GetDistrictList, GetDicData } from "@/api/admin/common.js";
import { UpdateTestMechanism, UpdateNickName } from "@/api/admin/login.js";
import { mapGetters } from "vuex";
import {
  isMobile,
  cardid,
  checkPassport,
  isTWCard,
  isHKCard,
} from "@/util/validate.js";
// 验证身份证是否正确
const chnNumber = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入身份证号码"));
  } else {
    if (cardid(value).status) {
      callback();
    } else {
      return callback(new Error(cardid(value).msg));
    }
  }
};
// 验证港澳居民
const chnNumber1 = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入港澳居民来往内地通行证身份证号码"));
  } else {
    if (isHKCard(value).status) {
      callback();
    } else {
      return callback(new Error(isHKCard(value).msg));
    }
  }
};
// 验证台湾身份证
const chnNumber2 = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入台湾居民来往大陆通行证身份证号码"));
  } else {
    if (isTWCard(value).status) {
      callback();
    } else {
      return callback(new Error(isTWCard(value).msg));
    }
  }
};
// 验证护照是否正确
const chnPassport = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入护照号码"));
  } else {
    if (checkPassport(value).errCode) {
      callback();
    } else {
      return callback(new Error(checkPassport(value).errMsg));
    }
  }
};
let that;
export default {
  computed: {
    ...mapGetters(["personalInfo", "userInfo"]),
  },
  data() {
    var checkTel = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if (isMobile(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的电话"));
        }
      }
    };
    return {
      ruleForm: {
        certificates_type: "1",
      },
      rules: {
        business_license: [
          {
            required: true,
            message: "请填写营业执照编号",
            trigger: "blur",
          },
        ],
        mechanism_fullName: [
          {
            required: true,
            message: "请填写机构名称",
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            message: "请选择省",
            trigger: "change",
          },
        ],
        city: [
          {
            required: true,
            message: "请选择市",
            trigger: "change",
          },
        ],
        district: [
          {
            required: true,
            message: "请选择地区",
            trigger: "change",
          },
        ],
        detailed_address: [
          {
            required: true,
            message: "请填写机构注册详细地址",
            trigger: "blur",
          },
        ],
        // office_address: [
        //   {
        //     required: true,
        //     message: "请填写办公地址",
        //     trigger: "blur"
        //   }
        // ],
        // principal: [
        //   {
        //     required: true,
        //     message: "请填写负责人姓名",
        //     trigger: "change"
        //   }
        // ],
        nickname: [{ required: true, message: "请填写简称", trigger: "blur" }],
        principal_tel: [
          {
            // required: true,
            validator: checkTel,
            trigger: "blur",
          },
        ],
        legal_person: [
          {
            required: true,
            message: "请选择法人姓名",
            trigger: "change",
          },
        ],
        certificates_type: [
          {
            required: true,
            message: "请选择法人证件类型",
            trigger: "change",
          },
        ],
        legal_person_idNumber: [
          {
            required: true,
            validator: chnNumber,
            trigger: "blur",
          },
        ],
        management_tel: [
          {
            // required: true,
            trigger: "blur",
            validator: checkTel,
          },
        ],
      },
      province: [],
      city: [],
      district: [],
      isdisabled: false,
      disabled: false,
      loading: false,
      dicData: {
        certificates_type: "certificates_type",
      },
      certificatesList: [],
      localFile: {},
      dialogVisible: false,
      dialogImageUrl: "",
      error: "",
      error1: "",
      error2: "",
      active: "",
      fileList: [],
      list: [],
      isSuccess: true,
    };
  },
  created() {
    this.getList();
  },
  beforeCreate: function () {
    that = this;
  },
  watch: {
    // "ruleForm.nickname"(val) {
    //    if (!val) {
    //       this.error1 = "";
    //    }
    // },
    "ruleForm.certificates_type"(val) {
      this.$refs.ruleForm.clearValidate("legal_person_idNumber");
      if (val == "1") {
        this.rules.legal_person_idNumber[0].validator = chnNumber;
      } else if (val == "2") {
        this.rules.legal_person_idNumber[0].validator = chnNumber1;
      } else if (val == "3") {
        this.rules.legal_person_idNumber[0].validator = chnNumber2;
      } else if (val == "4") {
        this.rules.legal_person_idNumber[0].validator = chnPassport;
      }
    },
  },
  methods: {
    getList() {
      // 数据回填
      this.$store.dispatch("GetPersonalInfo", this.userInfo).then((data) => {
        if (this.personalInfo) {
          this.isdisabled = true;
          this.disabled = true;
          this.ruleForm = data.userInfo;
          this.$refs.upLoad.$options._parentVnode.elm.childNodes[1].style =
            "display:none";
          if (data.userInfo.view1) {
            this.fileList.push({
              url: window.apiObj.apiUrl + data.userInfo.view1,
              id: data.userInfo.institutional_view1,
            });
          }
          if (data.userInfo.view2) {
            this.fileList.push({
              url: window.apiObj.apiUrl + data.userInfo.view2,
              id: data.userInfo.institutional_view2,
            });
          }
          if (data.userInfo.view3) {
            this.fileList.push({
              url: window.apiObj.apiUrl + data.userInfo.view3,
              id: data.userInfo.institutional_view3,
            });
          }
          GetDistrictList({ parent_id: "-1" }).then((data) => {
            if (data.data.result) {
              this.province = data.data.result.items;
            }
          });
          GetDistrictList({ parent_id: this.ruleForm.province }).then(
            (data) => {
              if (data.data.result) {
                this.city = data.data.result.items;
              }
            }
          );
          GetDistrictList({ parent_id: this.ruleForm.city }).then((data) => {
            if (data.data.result) {
              this.district = data.data.result.items;
            }
          });
        } else {
          this.isdisabled = false;
          this.disabled = false;
          this.ruleForm = {
            certificates_type: "1",
          };
          /*
          window.console.log(
             (this.$refs.upLoad.$options._parentVnode.elm.childNodes[1].style =
                "display:inline-block;")
          );
          */
        }
      });
      GetDistrictList({ parent_id: "-1" }).then((data) => {
        if (data.data.result) {
          this.province = data.data.result.items;
        }
      });
      GetDicData({ classCode: this.dicData.certificates_type }).then((data) => {
        if (data.data.result.length > 0) {
          this.certificatesList = data.data.result;
        }
      });
    },
    submit(ruleForm) {
      this.ruleForm.isFormSubmit = true;
      if (this.error1 || this.error2) {
        return;
      }
      this.subImgList();

      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.$confirm(
            "带*号信息为关键信息，提交后无法自行修改，请确认后提交?",
            "确认信息",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "提交",
            }
          ).then(() => {
            UpdateTestMechanism(this.ruleForm).then((data) => {
              this.disabled = false;
              window.location.reload();
            });
          });
        } else {
          return false;
        }
      });
    },
    edit() {
      this.disabled = false;
      this.$refs.upLoad.$options._parentVnode.elm.childNodes[1].style =
        "display:inline-block;";
      /*
      window.console.log(
         (this.$refs.upLoad.$options._parentVnode.elm.childNodes[1].style =
            "display:inline-block;")
      );
      */
    },
    edit1() {
      this.disabled = true;
      this.$refs.upLoad.$options._parentVnode.elm.childNodes[1].style =
        "display:none";
      /*
      window.console.log(
         (this.$refs.upLoad.$options._parentVnode.elm.childNodes[1].style =
            "display:none")
      );
      */
    },
    imgMouseover() {
      this.active = "display:block;opacity: 1;";
    },
    imgMouseleave() {
      this.active = "display:none;opacity: 0;";
    },
    chooseProvince(item) {
      GetDistrictList({ parent_id: item }).then((data) => {
        this.city = data.data.result.items;
        this.ruleForm.city = this.city[0].id;
        GetDistrictList({ parent_id: this.ruleForm.city }).then((data) => {
          this.district = data.data.result.items;
          this.ruleForm.district = this.district[0].id;
        });
      });
    },
    chooseCity(item) {
      GetDistrictList({ parent_id: item }).then((data) => {
        this.district = data.data.result.items;
        this.ruleForm.district = this.district[0].id;
      });
    },
    chooseDistrict() {
      this.$forceUpdate();
    },
    checkNickName(i) {
      if (i == 1) {
        this.error1 = "";
        if (this.ruleForm.nickname) {
          UpdateNickName({
            nickName: this.ruleForm.nickname,
            check_type: i,
          }).then((data) => {
            if (!data.data.result.isSuccess) {
              this.error1 = data.data.result.errorMsg;
            }
          });
        }
      } else if (i == 2) {
        this.error2 = "";
        if (this.ruleForm.mechanism_fullName) {
          UpdateNickName({
            mechanism_fullName: this.ruleForm.mechanism_fullName,
            check_type: i,
          }).then((data) => {
            if (!data.data.result.isSuccess) {
              this.error2 = data.data.result.errorMsg;
            }
          });
        }
      }
    },
    handleViewImg(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCard(file, fileList) {
      const isLt4M = file.raw.size / 1024 / 1024 < 1;
      if (!isLt4M) {
        this.$message.error("上传图片大小不能超过 1MB!");
        fileList.splice(fileList.indexOf(file), 1);
        return;
      }
      this.fileList = fileList;
    },
    onExceed() {
      this.$message.warning("最多可上次三张实景图照片");
    },
    handleRemove(file) {
      this.fileList.splice(
        this.fileList.findIndex((item) => item.uid == file.uid),
        1
      );

      //this.fileList = [];
    },
    subImgList() {
      /*this.list = [
         this.ruleForm.institutional_view1,
         this.ruleForm.institutional_view2,
         this.ruleForm.institutional_view3
      ];*/
      this.list = [];

      this.fileList.forEach((item, index) => {
        if (item.status != "success") {
          this.list.push(item.raw);
          //this.list[index] = this.fileList[index].raw;
        } else {
          this.list.push(item.id);
        }
      });

      this.ruleForm.institutional_view1 = this.list[0];
      this.ruleForm.institutional_view2 = this.list[1];
      this.ruleForm.institutional_view3 = this.list[2];
    },
  },
  filters: {
    type: (data) => {
      for (var i in that.certificatesList) {
        if (that.certificatesList[i].value == data) {
          return that.certificatesList[i].label;
        }
      }
    },
    pro: (data) => {
      for (var i in that.province) {
        if (that.province[i].id == data) {
          return that.province[i].area_name;
        }
      }
    },
    cit: (data) => {
      for (var i in that.city) {
        if (that.city[i].id == data) {
          return that.city[i].area_name;
        }
      }
    },
    dis: (data) => {
      for (var i in that.district) {
        if (that.district[i].id == data) {
          return that.district[i].area_name;
        }
      }
    },
  },
};
</script>
<style lang="less">
.testInfo {
  .form {
    width: 90%;

    .tips {
      font-weight: 350;
      color: #4e4e4e;
      line-height: 30px;
    }

    .friendshipTips {
      display: flex;

      p:nth-child(1) {
        padding: 0px 40px 0px 0px;
      }

      p:nth-child(2) {
        line-height: 5;
      }
    }

    .color {
      color: #ea0000;

      .el-form-item__label {
        color: #ea0000;
      }
    }

    // 去掉边框
    .border {
      .el-input__inner {
        border-width: 0px !important;
      }
    }

    .submit {
      .el-form-item__content {
        margin-left: 0px !important;
        text-align: center;
        margin: 30px 0px;
      }
    }

    .el-upload-list--picture-card .el-upload-list__item-thumbnail {
      width: 150px;
      height: 150px;
    }
  }

  @media screen and (max-width: 500px) {
    .quaul {
      width: 100% !important;
    }

    .form {
      width: 100% !important;

      .el-form-item__label {
        width: 110px !important;
        float: none;
      }

      .el-form-item__content {
        margin-left: 30px !important;
        float: none;
      }

      .content {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }

      .center {
        text-align: center;
      }
    }
  }
}
</style>
